import React from "react";
import localize, { LocKeys } from "../../../constants/localizations";
import { renderPrice } from "../../../components/orders/single-view/view/SpecificationView";

/**
 * Price summary for the create-order wizard (Order Flow V2).
 *
 * Used as the per-step "Total" row and — with `label` set to
 * `localize(LocKeys.GRAND_TOTAL)` and `variant="footer"` — as the running
 * grand-total rendered in every wizard step's footer next to the navigation
 * buttons (review 2026-06-09, §5: Subtotal per line, Total per step, Grand
 * total in the footer).
 *
 * The value is the grand offer total (`price.totalOfferPrice`), which the price
 * endpoint returns including the selected services (sent as `manuals`). When
 * the owning company does not estimate price the value is rendered as "-"
 * rather than a misleading 0.
 *
 * @param {Object}  props
 * @param {number}  props.totalPrice           price value to render
 * @param {string}  [props.label]              row label (defaults to "Total")
 * @param {string}  [props.variant="row"]      "row" = full-width body row,
 *                                             "footer" = inline "Label: value"
 * @param {boolean} [props.loading=false]      show a loader while pricing
 * @param {boolean} [props.shouldEstimatePrice=true] gate the value on the company flag
 * @returns
 */
const OrderTotal = ({
	totalPrice,
	label = null,
	variant = "row",
	loading = false,
	shouldEstimatePrice = true,
}) => {
	if (variant === "footer") {
		return (
			<h4 className="d-flex align-items-center">
				<span className="color-n300">{label || localize(LocKeys.TOTAL)}:</span>
				&nbsp;
				<span className="color-n500">
					{loading ? (
						<span className="loading-icon"></span>
					) : (
						renderPrice(shouldEstimatePrice ? totalPrice : null, "color-n500")
					)}
				</span>
			</h4>
		);
	}

	return (
		<div className="row row--6p-gutters align-items-start py-m">
			<div className="col col-75 color-n500">
				<h4>{label || localize(LocKeys.TOTAL)}</h4>
			</div>

			<div className="col col-25 justify-content-end">
				{loading ? (
					<span className="loading-icon"></span>
				) : (
					<h4>
						{renderPrice(shouldEstimatePrice ? totalPrice : null, "color-n500")}
					</h4>
				)}
			</div>
		</div>
	);
};

export default OrderTotal;
